import { wix } from './assets/proto-types/proto-generated';
export var ApiTypes = wix.social.groups.api;
export var FeedApiTypes = wix.feed;
export var CommentsApiTypes = wix.comments;
export var ReactionsApiTypes = wix.reactions;
export var SocialApiTypes = wix.social;
//# sourceMappingURL=types.js.map